import PropTypes from "prop-types";
import React, {FC} from "react";


const ErrorMessage: FC<{errorMessage: string}> = ({ errorMessage }) => {

  return (
    <div
      className="d-flex justify-content-center align-items-center text-center"
      style={{ minHeight: "100vh" }}
    >
      {errorMessage}
    </div>
  );
};

export default ErrorMessage;
